'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref, isRelativeHref } from '@eliadmin/core/src/utils/url-utils';
import Link from '@eliadmin/core/src/components/link';
import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';

export type CategoryMenuProps = {
  className?: string;
};

export function CategoryMenu(props: PropsWithChildren<CategoryMenuProps>) {
  return (
    <ul className={cn('flex flex-row items-center gap-2', 'ea-category-menu', props.className)}>
      {props.children}
    </ul>
  );
}

export type CategoryMenuItemProps = {
  title: string;
  href?: string;
  onClick?: () => void;
  order?: number;
  className?: {
    root?: string;
    link?: string;
  };
};

export function CategoryMenuItem(props: CategoryMenuItemProps) {
  const LinkComp = props.href ? (isRelativeHref(getSafeHref(props.href)) ? Link : 'a') : 'span';
  const pathname = usePathname();

  return (
    <li
      style={{ order: props.order }}
      className={cn(
        'relative flex flex-row',
        'ea-category-menu-item',
        {
          'ea-active-link': pathname === props.href,
        },
        props.className?.root,
      )}
    >
      <LinkComp {...(LinkComp === Link ? { prefetchOnHover: true } : {})}
        href={props.href ? getSafeHref(props.href) : (undefined as any)}
        className={cn('text-sm font-medium', 'ea-category-menu-item__link', props.className?.link)}
        onClick={props.onClick}
      >
        {props.title}
      </LinkComp>
    </li>
  );
}
